const webdb_name = 'zt';
const webdb_version = '1.0';
const tables = ['templateGroup', 'templateFree'];
const DB = {
    db: null,
    init(){
        const indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB;
        const request = indexedDB.open(webdb_name, webdb_version);
        request.onsuccess = e => {
            this.db = e.target.result;
            console.log('Init indexedDB successfully');
        };
        request.onupgradeneeded = e => {
            this.db = e.target.result;
            tables.forEach((storeName) => {
                if (!this.db.objectStoreNames.contains(storeName)) {
                    this.store = this.db.createObjectStore(storeName);
                }
            });
            console.log('DB version changed, db version: ', this.db.version);
        };
        request.onerror = e => {
            console.info('Can not open indexedDB', e);
        };
    },
};
DB.init();

class IndexedDB {
    constructor(storeName) {
        this.storeName = storeName;
    }
    get(key) {
        return new Promise((resolve, reject) => {
            const transaction = DB.db.transaction(this.storeName);
            const objectStore = transaction.objectStore(this.storeName);
            const request = objectStore.get(key);
            request.onerror = e => {
                console.info('Can not get value', e);
                reject(e);
            };
            request.onsuccess = e => {
                resolve(e.target.result);
            };
        });
    }

    set(key, value) {
        return new Promise((resolve, reject) => {
            this.get(key).then((data) => {
                if (data) {
                    this.update(key, value).then((val) => {
                        resolve(val)
                    }).catch(e => {
                        reject(e)
                    })
                } else {
                    const transaction = DB.db.transaction(this.storeName, 'readwrite');
                    const objectStore = transaction.objectStore(this.storeName);
                    const request = objectStore.add(value, key);
                    request.onerror = e => {
                        console.info('Can not add value', e);
                        reject(e)
                    };
                    request.onsuccess = e => {
                        resolve(e.target.result);
                    };
                }
            }).catch(e => {
                reject(e)
            });
        })
    }

    update(key, newValue) {
        return new Promise((resolve, reject) => {
            const transaction = DB.db.transaction(this.storeName, 'readwrite');
            const objectStore = transaction.objectStore(this.storeName);
            const request = objectStore.put(newValue, key);

            request.onerror = e => {
                console.info('Can not update value', e);
                reject(e);
            };
            request.onsuccess = e => {
                resolve(e.target.result);
            };
        })
    }

    remove(key) {
        const request = DB.db.transaction(this.storeName, 'readwrite')
            .objectStore(this.storeName)
            .delete(key);
        request.onerror = e => {
            console.info('Can not remove value', e);
        };
    }
    clearAll() {
        const transaction = DB.db.transaction(this.storeName, 'readwrite');
        if(!transaction){
            return;
        }
        const objectStore = transaction.objectStore(this.storeName);
        const request = objectStore.clear();
        request.onerror = e => {
            console.info('Can not clearAll', e);
        };
    }

    close() {
        DB.db.close();
    }
}

export default IndexedDB;